import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketOverview = () => {
  const marketStats = [
    {
      id: 1,
      title: "Total Market Value",
      value: "$2.4B",
      change: "+12.5%",
      changeType: "positive",
      icon: "TrendingUp",
      description: "Global collectibles market"
    },
    {
      id: 2,
      title: "Active Auctions",
      value: "1,247",
      change: "+8.2%",
      changeType: "positive",
      icon: "Gavel",
      description: "Live auction listings"
    },
    {
      id: 3,
      title: "Avg. Price Growth",
      value: "18.7%",
      change: "+2.1%",
      changeType: "positive",
      icon: "BarChart3",
      description: "Year over year"
    },
    {
      id: 4,
      title: "Market Volatility",
      value: "Low",
      change: "-5.3%",
      changeType: "negative",
      icon: "Activity",
      description: "Risk assessment"
    }
  ];

  const topCategories = [
    {
      id: 1,
      name: "Vintage Watches",
      value: "$485M",
      growth: "+24.3%",
      volume: "2,847 items",
      color: "from-amber-500 to-yellow-600"
    },
    {
      id: 2,
      name: "Sports Cards",
      value: "$312M",
      growth: "+18.7%",
      volume: "15,234 items",
      color: "from-blue-500 to-indigo-600"
    },
    {
      id: 3,
      name: "Comic Books",
      value: "$298M",
      growth: "+15.2%",
      volume: "8,956 items",
      color: "from-purple-500 to-pink-600"
    },
    {
      id: 4,
      name: "Art & Antiques",
      value: "$267M",
      growth: "+12.8%",
      volume: "1,423 items",
      color: "from-green-500 to-emerald-600"
    }
  ];

  return (
    <div className="space-y-6">
      {/* Market Statistics */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {marketStats?.map((stat) => (
          <div
            key={stat?.id}
            className="bg-card border border-border rounded-lg p-6 premium-hover"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                stat?.changeType === 'positive' ? 'bg-success/10' : 'bg-destructive/10'
              }`}>
                <Icon 
                  name={stat?.icon} 
                  size={24} 
                  className={stat?.changeType === 'positive' ? 'text-success' : 'text-destructive'} 
                />
              </div>
              <div className={`flex items-center space-x-1 text-sm font-medium ${
                stat?.changeType === 'positive' ? 'text-success' : 'text-destructive'
              }`}>
                <Icon 
                  name={stat?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
                  size={16} 
                />
                <span>{stat?.change}</span>
              </div>
            </div>
            
            <div className="space-y-1">
              <h3 className="text-2xl font-bold text-card-foreground">{stat?.value}</h3>
              <p className="text-sm font-medium text-card-foreground">{stat?.title}</p>
              <p className="text-xs text-muted-foreground">{stat?.description}</p>
            </div>
          </div>
        ))}
      </div>
      {/* Top Categories */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl font-bold text-card-foreground">Top Performing Categories</h2>
            <p className="text-sm text-muted-foreground">Market leaders by value and growth</p>
          </div>
          <button className="flex items-center space-x-2 px-4 py-2 bg-primary/10 text-primary rounded-lg hover:bg-primary/20 transition-colors duration-200">
            <Icon name="ExternalLink" size={16} />
            <span className="text-sm font-medium">View All</span>
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {topCategories?.map((category) => (
            <div
              key={category?.id}
              className="bg-muted/30 rounded-lg p-4 premium-hover"
            >
              <div className="flex items-center justify-between mb-3">
                <div className={`w-3 h-3 rounded-full bg-gradient-to-r ${category?.color}`}></div>
                <div className="flex items-center space-x-1 text-success text-sm font-medium">
                  <Icon name="TrendingUp" size={14} />
                  <span>{category?.growth}</span>
                </div>
              </div>
              
              <div className="space-y-2">
                <h3 className="font-semibold text-card-foreground">{category?.name}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-lg font-bold text-card-foreground">{category?.value}</span>
                  <span className="text-xs text-muted-foreground">{category?.volume}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarketOverview;